/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-edit-md': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7.396 8.714l-2.301.934A.796.796 0 0 1 4.058 8.61l.688-1.708c.348-.857.406-.977.506-1.077l5.59-5.59A.794.794 0 0 1 11.406 0l.125.01a.797.797 0 0 1 .44.223l1.504 1.505a.8.8 0 0 1-.005 1.125L7.865 8.468c-.065.062-.15.11-.469.246zM5.756 7.08l-.594 1.464.12-.048 1.636-.667.133-.057-1.116-1.117-.18.425zm2.05.033l4.815-4.815-1.214-1.214-4.814 4.815 1.214 1.214zM6.203 2.02a.5.5 0 0 1 .09.992l-.09.008h-3.81c-.296 0-.376.032-.39.15L2 3.219v8.468c0 .188.09.303.257.328l.076.006h8.526c.096 0 .128-.016.137-.168l.004-.166v-3.8a.5.5 0 0 1 .992-.09l.008.09v3.8c0 .745-.318 1.265-1 1.327l-.14.007H2.332c-.722 0-1.266-.502-1.327-1.2L1 11.686V3.22c0-.754.499-1.148 1.24-1.194l.151-.004h3.811z" _fill="#234357"/>'
  }
})
